/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Art_BodyInputs */

const en_svc_rag_art_body = /** @type {(inputs: Svc_Rag_Art_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellations need 48 hours’ notice. Inside 48 hours, the deposit is kept unless the manager approves an exception.`)
};

const lv_svc_rag_art_body = /** @type {(inputs: Svc_Rag_Art_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par atcelšanu jāpaziņo 48 stundas iepriekš. Ja paziņojums nāk vēlāk, depozīts netiek atmaksāts, ja vien vadītājs neapstiprina izņēmumu.`)
};

/**
* | output |
* | --- |
* | "Cancellations need 48 hours’ notice. Inside 48 hours, the deposit is kept unless the manager approves an exception." |
*
* @param {Svc_Rag_Art_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_art_body = /** @type {((inputs?: Svc_Rag_Art_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Art_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_art_body(inputs)
	return en_svc_rag_art_body(inputs)
});